import * as React from "react";
import StudentSchedule from "./StudentSchedule.tsx";
import TeacherSchedule from "./TeacherSchedule.tsx";
import { GraduationCap } from "lucide-react";
import { Plus } from "lucide-react";
import { UserRoundPlus } from "lucide-react";

export default function FloatingActionButton() {
  const [isOpen, setOpen] = React.useState(false);
  const [isModalStudent, setModalStudent] = React.useState(false);
  const [isModalTeacher, setModalTeacher] = React.useState(false);
  console.log("FAB");
  return (
    <div className="flex w-10 h-full flex-col justify-between items-stretch ">
      <Plus
        onClick={() => setOpen(!isOpen)}
        className="fixed w-auto h-10 bg-green-500 rounded-full bottom-5 right-5 border-none"
      />

      {isOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full"
          onClick={() => setOpen(false)}
        >
          <>
            <div onClick={(e) => e.stopPropagation()}>
              <GraduationCap
                onClick={() => {
                  setModalStudent(true);
                }}
                className="fixed w-auto h-10 bg-green-500 bottom-35 right-5 border-none rounded-full"
              />
              <UserRoundPlus
                onClick={() => setModalTeacher(true)}
                className="fixed w-auto h-10 bg-green-500 bottom-20 right-5 border-none rounded-full"
              />
            </div>
          </>
        </div>
      )}

      {isModalTeacher && (
        <TeacherSchedule
          state={isModalTeacher}
          setModalState={setModalTeacher}
        />
      )}
      {isModalStudent && (
        <StudentSchedule
          state={isModalStudent}
          setModalState={setModalStudent}
        />
      )}
    </div>
  );
}
